import { NgModule } from '@angular/core';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { SharedModule } from '../../../../../shared';
import { ClassificacaoTipoMultiselectModule } from '../../../../classificacao/tipo/multiselect';
import { CrossSellMultiselectModule } from '../../../../common/cross-sell/components/multiselect';
import { PedidoStatusModule } from '../../../../pedido/status/pedido-status.module';
import { ClienteTypeaheadSharedModule } from '../../../../pessoa/cliente/typeahead/cliente-typeahead-shared.module';
import { RepresentanteMultiselectModule } from '../../../../pessoa/representante/multiselect';

import { ProdutividadeFilterComponent } from './produtividade-filter.component';

@NgModule({
    imports: [
        SharedModule,
        ClassificacaoTipoMultiselectModule,
        RepresentanteMultiselectModule,
        NgxBootstrapMultiselectModule,
        CrossSellMultiselectModule,
        PedidoStatusModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        ProdutividadeFilterComponent
    ],
    exports: [
        ProdutividadeFilterComponent
    ]
})
export class ProdutividadeFilterModule { }
